import React from 'react';
import { Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  WOLT_DIRECTION_OPTIONS,
  WOLT_KIND_OPTIONS,
  WOLT_STATUS_OPTIONS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type WoltCallLogsFiltersProps = Pick<
  UseMonitoringPage,
  | 'woltTenantFilter' | 'setWoltTenantFilter'
  | 'woltTenantOptions'
  | 'woltDirectionFilter' | 'setWoltDirectionFilter'
  | 'woltKindFilter' | 'setWoltKindFilter'
  | 'woltStatusFilter' | 'setWoltStatusFilter'
  | 'woltSearch' | 'setWoltSearch'
  | 'woltDateFilterMode' | 'setWoltDateFilterMode'
  | 'woltExactDate' | 'setWoltExactDate'
  | 'woltDateFrom' | 'setWoltDateFrom'
  | 'woltDateTo' | 'setWoltDateTo'
  | 'clearWoltFilters'
>;

export const WoltCallLogsFilters: React.FC<WoltCallLogsFiltersProps> = ({
  woltTenantFilter,
  setWoltTenantFilter,
  woltTenantOptions,
  woltDirectionFilter,
  setWoltDirectionFilter,
  woltKindFilter,
  setWoltKindFilter,
  woltStatusFilter,
  setWoltStatusFilter,
  woltSearch,
  setWoltSearch,
  woltDateFilterMode,
  setWoltDateFilterMode,
  woltExactDate,
  setWoltExactDate,
  woltDateFrom,
  setWoltDateFrom,
  woltDateTo,
  setWoltDateTo,
  clearWoltFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <Select
          label={'עסק'}
          placeholder={'בחר עסק'}
          data={woltTenantOptions}
          value={woltTenantFilter || null}
          onChange={(value) => setWoltTenantFilter(value ?? '')}
          searchable
          clearable
          data-testid="monitoring-wolt-filter-tenant"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'כיוון'}
          placeholder={'בחר כיוון'}
          data={WOLT_DIRECTION_OPTIONS}
          value={woltDirectionFilter || null}
          onChange={(value) => setWoltDirectionFilter(value ?? '')}
          clearable
          data-testid="monitoring-wolt-filter-direction"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סוג'}
          placeholder={'בחר סוג'}
          data={WOLT_KIND_OPTIONS}
          value={woltKindFilter || null}
          onChange={(value) => setWoltKindFilter(value ?? '')}
          clearable
          data-testid="monitoring-wolt-filter-kind"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סטטוס'}
          placeholder={'בחר סטטוס'}
          data={WOLT_STATUS_OPTIONS}
          value={woltStatusFilter || null}
          onChange={(value) => setWoltStatusFilter(value ?? '')}
          clearable
          data-testid="monitoring-wolt-filter-status"
        />
      </div>

      <div className={classes.fieldStack}>
        <TextInput
          label={'חיפוש'}
          placeholder={'שגיאה או מזהה הזמנה'}
          value={woltSearch}
          onChange={(event) => setWoltSearch(event.currentTarget.value)}
          data-testid="monitoring-wolt-filter-search"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={woltDateFilterMode}
          onChange={(value) => setWoltDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-wolt-date-mode"
        />
        {woltDateFilterMode === 'exact' && (
          <TextInput type="date" value={woltExactDate} onChange={(event) => setWoltExactDate(event.currentTarget.value)} data-testid="monitoring-wolt-date-exact" />
        )}
        {woltDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={woltDateFrom} onChange={(event) => setWoltDateFrom(event.currentTarget.value)} data-testid="monitoring-wolt-date-from" />
            <TextInput type="date" value={woltDateTo} onChange={(event) => setWoltDateTo(event.currentTarget.value)} data-testid="monitoring-wolt-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearWoltFilters} dataTestId="monitoring-wolt-clear-filters">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
